module.exports = __webpack_public_path__ + "static/apac-b0d89f5ecef1602add55590157e6777c.jpg";